module.exports = __webpack_public_path__ + "static/media/image (57).e0c30125.jpg";